var dust = require('dustjs-linkedin');
(function(dust){dust.register("cookie",body_0);function body_0(chk,ctx){return chk.w("<div class=\"cookie-container\"><div class=\"cookie-text\">").f(ctx.get(["text"], false),ctx,"h").w("<a href=\"").f(ctx.get(["link"], false),ctx,"h").w("\" class=\"cookie-link\">").f(ctx.get(["text_link"], false),ctx,"h").w("</a></div><div class=\"cookie-button\"><div class=\"cookie-confirm pointer\">").f(ctx.get(["button"], false),ctx,"h").w("</div></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
module.exports = 'cookie';


//////////////////
// WEBPACK FOOTER
// ./src/common/templates/cookie.dust
// module id = 387
// module chunks = 0 1